import script from "./cold.vue?vue&type=script&setup=true&lang=js"
export * from "./cold.vue?vue&type=script&setup=true&lang=js"

import "./cold.vue?vue&type=style&index=0&id=123b4869&lang=less"

const __exports__ = script;

export default __exports__